import { BasicLayout } from '@tencent/tds-ui/src/layout';
import { TdsFooter } from '@tencent/tds-ui/src/tds-footer';
import { useLocalStorageState, useSize } from 'ahooks';
import { Carousel, Modal, Spin, Typography } from 'antd';
import axios from 'axios';
import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useHistory, useLocation,
} from 'react-router-dom';
import BuglyCopilotIcon from '@/assets/images/header/bugly-copilot-icon.svg?react';
import NoticeInfoIcon from '@/assets/images/icons/notice-info.react.svg?react';
import BuglySgpIcon from '@/assets/images/public/bugly-sgp.react.svg?react';
import BuglyEnIcon from '@/assets/images/public/TDS-bugly-pre-en.react.svg?react';
import BuglyIcon from '@/assets/images/public/TDS-bugly-pre.react.svg?react';
import { MultiApp, useAppConfig } from '@/config/context';
import { userImplement } from '@/config/hooks/user';
import { isDji, isPro, isSgp, isWOA } from '@/infrastructure/auth';
import {
  BASE_NAME,
  getParamFromUrl,
  pushHistory,
} from '@/infrastructure/history';
import { logger } from '@/infrastructure/logger';
import { getPlatform, getProductId } from '@/infrastructure/product-info';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { ArrearsReminder } from '@/presentation/components/arrears-reminder';
import noticeStyles from '@/presentation/components/operation-notice/index.module.scss';
import useToggle from '@/presentation/components/toggle/use-toggle';
import { useAuthContext } from '@/presentation/hooks';
import { Content } from '@/presentation/layouts-pro/content';
import { TopMenu } from '@/presentation/layouts-pro/header';
import { AppList } from '@/presentation/layouts-pro/header/app-list';
import { SailingPlan } from '@/presentation/layouts-pro/header/sailing-plan';
import { Tools } from '@/presentation/layouts-pro/tools';
import {
  getEntriesRoutes,
} from '@/presentation/routes/routes';
import { stores, useStores } from '@/presentation/store';
import { llmOauthService } from '@/service/llm-oauth';
import { AppSlot } from '../components/app-slot';
import { SgpFooterLite } from '../components/sgp-footer';
import { CopilotAgentWrapper } from './header/copilot/agent';
import style from './index.module.scss';


interface NoticeInfoType {
  _id?: string,
  _mtime?: string,
  mainTitle?: string,
  functionTitle?: string,
  desc?: string,
  detailLink?: string,
  imageUrl?: string[],
  expireTime?: string,
  hasClosed?: boolean,
  whiteList?: string[],
  appVersion?: string[],
  isLinkNeedModify?: boolean,
}

export const ProAppLayout = observer(() => {
  const { t, i18n } = useTranslation();
  const isEnLocale = i18n.language === 'en-US';
  const { productId,
    permission,
    setExceed,
    loaded,
    hasProduct,
    setLoaded,
    setOverdueDataRecoveryBanner,
    setComplianceBanner,
  } = stores.ProductStore;
  const urlProductId = getParamFromUrl('productId');
  const {
    collapsed,
    setCollapsed,
    layoutLoading,
    loadingMessage,
    pgid,
    copilotChatVisible,
    copilotChatWidth,
    setCopilotVisible,
    isInLLMWhitelist,
    setIsInLLMWhitelist,
  } = stores.LayoutStore;
  const { authInfo } = useAuthContext();

  // 悬浮球拖拽相关状态
  const [ballPosition, setBallPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStartPos = useRef({ x: 0, y: 0 });
  const ballRef = useRef<HTMLDivElement>(null);

  const history = useHistory();
  const location = useLocation();
  const config = useAppConfig();
  const { Paragraph } = Typography;
  const [currPlatform, setCurrPlatform] = useState<string>();
  const [noticeInfo, setNoticeInfo] = useLocalStorageState<Record<string, NoticeInfoType>>('notice-info-storage-pro');
  const [latestNoticeInfo, setLatestNoticeInfo] = useLocalStorageState<Record<string, string>>('latest-noticeInfo-storage-pro');
  const [localStorageCount, setLocalStorageCount] = useLocalStorageState<number>(`${getProductId()}_compliance-modal-count`, {
    defaultValue: 0,
  });
  const handlePath = (path: string) => {
    pushHistory(history, path);
  };

  const windowSize = useSize(window.document.body);
  const [enabled] = useToggle('trialApply', ['user']);
  const isConfig = location.pathname.includes('/config-manage');
  const isTrial = location.pathname.includes('/trial-apply');
  const isResourcePack = location.pathname.includes('/resource-pack');
  const liteModeRoutes = [
    '/workbench/apps',
    '/user/profile',
    '/user/coupons',
    '/config-manage',
    '/product-approval',
    '/product-approval/details',
    '/usage-details',
    '/resource-pack',
    '/order',
    '/resource-manage',
    '/expense',
    '/expense/order-details',
    '/consult',
    '/trial-apply',
    '/trial-approval',
    '/resource-manage-details',
    '/month-resource-details',
    '/user/token',
    '/credit-resource-details',
  ];

  const notAllowedList = [
    '1706673809939273',
    '5943215790453768',
    '6103139469439906',
    '6445846140145416',
    '9695013078774720',
  ];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShowComplianceModal, setIsShowComplianceModal] = useState(false);
  const [complianceModalVisible, setComplianceModalVisible] = useState(false);
  const { complianceBanner = {} } = useStores().ProductStore;
  const { recommendVersion, versionTips } = complianceBanner;
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setNoticeInfo({
      ...noticeInfo,
      [currPlatform as string]: {
        ...noticeInfo?.[currPlatform as string],
        hasClosed: true,
      },
    });
    setIsModalOpen(false);
    reportClick(pgid, CUSTOM_ACTIONS.noticeModalView, {
      from: pgid,
    });
  };
  const renderWithLineBreaks = (value?: string) => (
    value?.split(/\\n|\n/).map((line, index, lines) => (
      <React.Fragment key={`${line}-${index}`}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ))
  );
  const handleComplianceModalOk = () => {
    const url = new URL(window.location.origin);
    const productId = getParamFromUrl('productId');
    url.pathname = `${BASE_NAME}/compliance-buttetin`;
    if (productId) {
      url.searchParams.set('appId', productId);
    }
    try {
      url.searchParams.set('versionTips', encodeURIComponent(JSON.stringify(versionTips)));
    } catch (e) {
      logger.error(e);
    }
    setComplianceModalVisible(false);
    setTimeout(() => window.open(url.toString(), '_blank'), 100);

    setLocalStorageCount((localStorageCount || 0) + 1);
  };

  const handleComplianceModalCancel = () => {
    setComplianceModalVisible(false);
    setLocalStorageCount((localStorageCount || 0) + 1);
  };
  const viewDetail = () => {
    let modifiedUrl: string;
    if (noticeInfo?.[currPlatform as string]?.isLinkNeedModify) { // 替换域名和productId
      try {
        const parsedUrl = new URL(noticeInfo?.[currPlatform as string]?.detailLink || '');
        parsedUrl.hostname = window.location.hostname;
        const params = new URLSearchParams(parsedUrl.search);
        if (params.has('productId')) {
          const productId = getProductId();
          params.set('productId', productId);
          parsedUrl.search = params.toString();
        }
        modifiedUrl = parsedUrl.toString();
      } catch (error) {
        logger.error('无效的 URL', error);
      }
    } else {
      modifiedUrl = noticeInfo?.[currPlatform as string]?.detailLink as string;
    }
    setIsModalOpen(false);
    setTimeout(() => window.open(modifiedUrl, '_blank'), 100);
    // eslint-disable-next-line max-len
    setNoticeInfo({ ...noticeInfo, [currPlatform as string]: { ...(noticeInfo?.[currPlatform as string]), hasClosed: true } });

    reportClick(pgid, CUSTOM_ACTIONS.noticeModalViewDetail, {
      from: pgid,
    });
  };
  const noticeInfoQuery = async () => {
    const noticeUrlObj = new URL(config.noticeRequestURL);
    const searchParams = new URLSearchParams(noticeUrlObj.search);
    const filter = searchParams.get('filter');// 获取注入url的filter参数

    const currTime = moment().unix();
    searchParams.set('filter', `expireTime>${currTime}&${filter}`);// 更新filter参数包含过期时间的筛选

    noticeUrlObj.search = searchParams.toString();
    const noticeURL = noticeUrlObj.toString();

    try {
      const res = await axios.get(
        noticeURL,
        { withCredentials: true },
      );
      return res.data;
    } catch {
      return null;
    }
  };

  const load = async () => {
    if (liteModeRoutes.includes(location.pathname)) { // 用户没有进到具体的产品页直接不请求
      return;
    }
    const originNoticeInfo = await noticeInfoQuery();
    if (originNoticeInfo?.data?.length === 0) { // 管理台无数据直接返回
      return;
    }
    const lastModifyItem = originNoticeInfo?.data?.filter((info: any) => info?.platform?.includes(currPlatform))?.[0];
    let whiteList;
    if (isSgp()) {
      whiteList = lastModifyItem?.whiteListForSgp;
    } else if (isPro() || isDji()) {
      whiteList = lastModifyItem?.whiteListForPro;
    } else if (isWOA()) {
      whiteList = lastModifyItem?.whiteListForOA;
    }

    if (
      !lastModifyItem // 没有需要展示的弹窗
      || (whiteList?.length !== 0
        && !whiteList?.includes(userImplement.getUserId()))// 运营配置了白名单且用户不在白名单
      || notAllowedList?.includes(userImplement.getUserId()) // hardcode,不对国网开放
    ) {
      return;
    }

    if (
      ((!noticeInfo?.[currPlatform as string] && (lastModifyItem?._id !== latestNoticeInfo?._id
        || lastModifyItem?._mtime !== latestNoticeInfo?._mtime)) // 没有历史通知信息且拉到的消息没过期
        || (noticeInfo?.[currPlatform as string]
          && (((lastModifyItem._id !== noticeInfo?.[currPlatform as string]?._id
            || lastModifyItem._mtime
            !== noticeInfo?.[currPlatform as string]?._mtime) && (lastModifyItem?._id !== latestNoticeInfo?._id
              || lastModifyItem?._mtime !== latestNoticeInfo?._mtime))
            || !noticeInfo?.[currPlatform as string]?.hasClosed))) && !complianceModalVisible
      // 拉取到的最新通知信息和存储的通知信息对比 须满足「id不同或者同一id但被修改过或者相同的弹窗但之前用户没有关闭」
    ) {
      setIsModalOpen(true);
      try {
        setNoticeInfo({ ...noticeInfo, [currPlatform as string]: lastModifyItem });
        setLatestNoticeInfo({ ...latestNoticeInfo, _id: lastModifyItem?._id, _mtime: lastModifyItem?._mtime });
      } catch {
        logger.error();
      }
    }
  };

  const onOpenFromFloatingBall = () => {
    // 只有在没有拖拽时才打开面板
    if (!isDragging) {
      setCopilotVisible(true);
    }
  };

  // 验证用户是否在 LLM 白名单中（海外版不提供该能力，不调接口）
  const verifyLLMWhitelist = async () => {
    if (isSgp()) {
      setIsInLLMWhitelist(false);
      return;
    }
    try {
      const result = await llmOauthService.verifyUserLLMWhite();

      // 根据返回结果判断是否在白名单中
      // result?.authorize 表示是否有权限
      setIsInLLMWhitelist(!!result?.authorize);
    } catch (error) {
      logger.error('验证 LLM 白名单失败:', error);
      setIsInLLMWhitelist(false);
    }
  };

  // 处理鼠标按下
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    dragStartPos.current = { x: e.clientX, y: e.clientY };

    // 拖拽时禁用 transition
    if (ballRef.current) {
      ballRef.current.style.transition = 'none';
    }

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const deltaX = Math.abs(moveEvent.clientX - dragStartPos.current.x);
      const deltaY = Math.abs(moveEvent.clientY - dragStartPos.current.y);

      // 移动超过5px才认为是拖拽
      if (deltaX > 5 || deltaY > 5) {
        setIsDragging(true);
      }

      if (ballRef.current) {
        const rect = ballRef.current.getBoundingClientRect();
        const newX = moveEvent.clientX - rect.width / 2;
        const newY = moveEvent.clientY - rect.height / 2;

        // 限制在视口范围内
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        const clampedX = Math.max(0, Math.min(newX, maxX));
        const clampedY = Math.max(0, Math.min(newY, maxY));

        // 直接操作 DOM，避免 React 状态更新延迟
        ballRef.current.style.left = `${clampedX}px`;
        ballRef.current.style.top = `${clampedY}px`;
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);

      // 恢复 transition（用于 hover 效果）
      if (ballRef.current) {
        ballRef.current.style.transition = '';
      }

      // 同步最终位置到 state
      if (ballRef.current) {
        const left = parseFloat(ballRef.current.style.left) || 0;
        const top = parseFloat(ballRef.current.style.top) || 0;
        setBallPosition({ x: left, y: top });
      }

      // 延迟重置拖拽状态，避免触发点击
      setTimeout(() => setIsDragging(false), 100);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // 窄版 最大1220
  const narrowRoutes = [
    '/resource-pack',
  ];

  const isNarrowMode = narrowRoutes.includes(location.pathname);

  const initRedirect = async () => {
    // 未登录，访问根路径，跳转首页
    // 无产品选中，跳首页 登录了情况才跳
    if (!urlProductId && !liteModeRoutes.includes(location.pathname)) {
      window.location.href = '/';
      return;
    }

    // 与产品无关的页面，直接render
    if (liteModeRoutes.includes(location.pathname)) {
      setLoaded(true);
    }
  };

  useEffect(() => {
    initRedirect();
  }, [location.pathname]);

  // productID变化重新执行初始化
  useEffect(() => {
    if (authInfo?.isLoggedIn) {
      stores.ProductStore.init();
      // 产品切换时重新验证白名单
      verifyLLMWhitelist();
    }
  }, [urlProductId]);

  useEffect(() => {
    if (isShowComplianceModal && (localStorageCount || 0) < 3) {
      setComplianceModalVisible(true);
    }
  }, [isShowComplianceModal]);

  useEffect(() => {
    // 等产品初始化完了，并且有权限情况下，再去拉流量包的信息, 不阻塞初始化
    if (loaded && productId && permission) {
      setExceed();
      setOverdueDataRecoveryBanner();
      setComplianceBanner();
    }
  }, [loaded, productId, permission]);

  useEffect(() => {
    setCurrPlatform(getPlatform());
  }, [getPlatform()]);

  useEffect(() => {
    if (authInfo?.isLoggedIn) {
      load();
    }
  }, [currPlatform, location.pathname]);

  // 验证 LLM 白名单
  useEffect(() => {
    if (authInfo?.isLoggedIn) {
      verifyLLMWhitelist();
    }
  }, [authInfo?.isLoggedIn]);

  useEffect(() => {
    const layoutHeader = document.querySelector('#layoutWithChatContainer .ant-pro-fixed-header');

    if (copilotChatVisible) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }

    if (!copilotChatVisible && layoutHeader instanceof HTMLElement) {
      layoutHeader.style.width = '100%';
      return;
    }

    if (copilotChatVisible && layoutHeader instanceof HTMLElement) {
      const windowWidth = window.innerWidth;
      layoutHeader.style.width = `${windowWidth - copilotChatWidth}px`;
    }
  }, [copilotChatWidth, copilotChatVisible, windowSize?.width]);

  // 没登录不render
  if (!authInfo?.isLoggedIn) {
    return null;
  }

  return (
    <Spin
      spinning={layoutLoading}
      tip={loadingMessage}
      className={style.loading}
    >
      <div className={style.layoutWithChat} id='layoutWithChatContainer'>
        <div className={style.withoutChat} id='layoutWithoutChatContainer'>
          <BasicLayout
            menuProps={{
              className: style.menu,
            }}
            mainMenuLink={'/overview'}
            narrow={isNarrowMode}
            liteMode={false}
            showBreadcrumb={hasProduct}
            enableSiderMenuEllipsisTooltip
            className={classnames({
              [style.app]: true,
              [style.config]: isConfig,
              [style.trial]: isTrial,
              [style.resourcePack]: isResourcePack && enabled,
            })}
            leftMenuRoutes={{ routes: getEntriesRoutes() }}
            appSelector={<AppList />}
            topMenu={<TopMenu />}
            sailingPlan={isResourcePack && enabled ? <SailingPlan /> : null}
            liteModeRoutes={liteModeRoutes}
            logo={
              <a href={'/'}>
                <AppSlot apps={[MultiApp.Pro, MultiApp.Dji, MultiApp.Eu]}>{isEnLocale
                  ? <BuglyEnIcon /> : <BuglyIcon />}</AppSlot>
                <AppSlot apps={[MultiApp.Sgp]}>
                  <BuglySgpIcon />
                </AppSlot>
              </a>
            }
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handlePath={handlePath}
            title={'Bugly'}
            renderBanner={(
              showBanner,
              setShowBanner,
              showOverdueDataBanner,
              setShowOverdueDataBanner,
              showArrearsBanner,
              setShowArrearsBanner,
              showComplianceBanner,
              setShowComplianceBanner,
            ) => <ArrearsReminder
                showArrearsBanner={showArrearsBanner}
                setShowArrearsBanner={setShowArrearsBanner}
                showOverdueDataBanner={showOverdueDataBanner}
                setShowOverdueDataBanner={setShowOverdueDataBanner}
                showComplianceBanner={showComplianceBanner}
                setShowComplianceBanner={setShowComplianceBanner}
                showBanner={showBanner}
                setShowBanner={setShowBanner}
                isShowComplianceModal={isShowComplianceModal}
                setIsShowComplianceModal={setIsShowComplianceModal}
                liteModeRoutes={liteModeRoutes}
              />

            }
          >
            <div className={classnames(style.containerLayout, 'content-layout')}>
              <Content />
              {isTrial ? null : (
                <Fragment>
                  <AppSlot apps={[MultiApp.Sgp]}>
                    <SgpFooterLite
                      locale={'EN'}
                      isTdsQQ
                      serviceTermUrl={'https://bugly.tds.tencent.com/docs/other/Bugly_Terms_Of_Service'}
                      privacyPolicyUrl={'https://bugly.tds.tencent.com/docs/other/Bugly_Privacy_Policy'}
                      cookiePolicyUrl={'https://bugly.tds.tencent.com/docs/other/Bugly_Cookies_Policy/'}
                    />
                  </AppSlot>
                  <AppSlot apps={[MultiApp.Pro, MultiApp.Dji, MultiApp.Eu]}>
                    <TdsFooter
                      isWoa={false}
                    />
                  </AppSlot>
                </Fragment>
              )}
              <Tools />
            </div>
          </BasicLayout>
        </div>

        <div className={style.withChat}>
          {isInLLMWhitelist && copilotChatVisible && <CopilotAgentWrapper />}
        </div>

        {/* 悬浮球 - 当 copilot 面板关闭时显示，且用户在白名单中 */}
        {(isInLLMWhitelist && !copilotChatVisible && !liteModeRoutes.includes(location.pathname)) && (
          <div
            ref={ballRef}
            className={style.floatingBall}
            onClick={onOpenFromFloatingBall}
            onMouseDown={handleMouseDown}
            style={{
              left: ballPosition.x || undefined,
              top: ballPosition.y || undefined,
              cursor: isDragging ? 'grabbing' : 'grab',
            }}
          >
            <BuglyCopilotIcon />
          </div>
        )}

      </div>
      <Modal
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className={noticeStyles.modal}
        footer={null}
        maskClosable={false}
        keyboard={false}
        centered={true}
      >
        <div className={noticeStyles.modalBox}>
          <div className={noticeStyles.leftBox}>
            <div className={noticeStyles.mainTitle}>
              <NoticeInfoIcon />
              <span>{renderWithLineBreaks(noticeInfo?.[currPlatform as string]?.mainTitle)}</span>
            </div>
            <div className={noticeStyles.functionTitle}>
              {renderWithLineBreaks(noticeInfo?.[currPlatform as string]?.functionTitle)}
            </div>
            <Paragraph
              className={noticeStyles.desc}
            >
              <div dangerouslySetInnerHTML={{ __html: noticeInfo?.[currPlatform as string]?.desc || '' }} />
            </Paragraph>
            <div
              className={noticeStyles.viewDetailBox}
              onClick={viewDetail}
            >
              <span className={noticeStyles.viewDetailText}>{t('查看详情')}</span>
            </div>
          </div>
          <div className={noticeStyles.rightSlide}>
            <Carousel autoplay dots={true}>
              {noticeInfo?.[currPlatform as string]?.imageUrl?.map?.((url, idx) => (
                <img src={url || ''} key={idx} alt={`notice-${idx}`} />
              ))}
            </Carousel>
          </div>
        </div>
      </Modal>
      <Modal
        title={t('升级提醒')}
        visible={complianceModalVisible}
        centered
        onCancel={handleComplianceModalCancel}
        onOk={handleComplianceModalOk}
        cancelText={t('取消')}
        okText={t('查看详情')}
        className={style.complianceModal}
      >
        {t('我们检测到您当前使用的版本并非最新版本。为保障应用合规性，请尽快升级至{{recommendVersion}}或者更高版本，并保证按最新监管要求初始化SDK。点击查看详情，了解更多信息。', { recommendVersion })}
      </Modal>
    </Spin>
  );
});
